import moment from "moment";

export const validate = (element) => {

  let error = [true, ''];

  if (element.type === "email") {
    let valid = /\S+@\S+\.\S+/.test(element.value);
    let message = `${!valid ? 'Must be a valid email' : ''}`;

    if (valid) {
      valid = new RegExp("^[A-Za-z0-9._%+-]+@rnp\.gov\.rw$").test(element.value);
      message = !valid ? "Email not allowed !" : '';
    }

    error = !valid ? [valid, message] : error
  }

  if (element.required) {
    const valid = element.value?.trim() !== '';
    const message = `${!valid ? 'This field is required' : ''}`;
    error = !valid ? [valid, message] : error
  }
  if (element.maxLength) {
    const valid = element.value.length <= element.maxLength;
    const message = `${!valid ? `Max-Length must be less than or equal to ${element.maxLength}` : ''}`;
    error = !valid ? [valid, message] : error
  }
  if (element.max !== undefined && element.max !== null && typeof element.max == 'number') {
    const valid = parseFloat(element.value) <= element.max;
    const message = `${!valid ? `Value must be less than or equal to ${element.max}` : ''}`;
    error = !valid ? [valid, message] : error
  }
  if (element.minLength && (element.required || element.value.length)) {
    const valid = element.value.length >= element.minLength;
    const message = `${!valid ? `Min-Length must be greater than or equal to ${element.minLength}` : ''}`;
    error = !valid ? [valid, message] : error
  }
  if (element.name === "phoneNo") {
    const valid = element.value.startsWith("07");
    const message = `${!valid ? `Phone Number must start with 07` : ''}`;
    error = !valid ? [valid, message] : error
  }
  if (element.name === "phoneNo") {
    const valid = /[0-9]+$/.test(element.value)
    const message = `${!valid ? `Phone Number must contain only numbers` : ''}`;
    error = !valid ? [valid, message] : error
  }
  if (element.name === 'startDate' || element.name === 'date') {
    const today = moment(new Date()).startOf('day');
    var newStartDate = moment(element.value);

    const valid = newStartDate >= today;
    const message = `${!valid ? `Date cannot backdated` : ''}`;
    error = !valid ? [valid, message] : error
  }
  if (element.name === 'endDate') {
    const today = moment(new Date()).startOf('day');
    var newEndDate = moment(element.value);

    const valid = newEndDate >= today;
    const message = `${!valid ? `Date cannot backdated` : ''}`;
    error = !valid ? [valid, message] : error
  }

  return error;
}